/* eslint-disable no-continue -- Tokenizer branches deliberately advance to the next input token. */
const RAW_TEXT_TAGS = new Set(['script', 'style', 'textarea', 'title', 'xmp', 'iframe',
    'noembed', 'noframes', 'noscript']);

// eslint-disable-next-line import/prefer-default-export
export const candidateRootAttributes = (html: string): Partial<Record<'html' | 'body', string>> => {
    const roots: Partial<Record<'html' | 'body', string>> = {};
    const lower = html.toLowerCase();
    let offset = 0;
    let templateDepth = 0;
    while (offset < html.length) {
        const start = html.indexOf('<', offset);
        if (start < 0) break;
        if (html.startsWith('<!--', start)) {
            const endComment = html.indexOf('-->', start);
            if (endComment < 0) break;
            offset = endComment + '-->'.length;
            continue;
        }
        const prefix = html.slice(start).match(/^<(\/)?([a-z][a-z\d:-]*)\b/i);
        if (!prefix) {
            offset = start + 1;
            continue;
        }
        const [, closingTag, tagName] = prefix;
        const closing = Boolean(closingTag);
        const name = tagName.toLowerCase();
        let quote = '';
        let end = start + prefix[0].length;
        for (; end < html.length; end++) {
            const character = html[end];
            if (quote) {
                if (character === quote) quote = '';
            } else if (character === '"' || character === "'") quote = character;
            else if (character === '>') break;
        }
        if (end >= html.length) break;
        offset = end + 1;
        if (name === 'template') templateDepth = Math.max(0, templateDepth + (closing ? -1 : 1));
        if (closing) continue;
        if (name === 'plaintext') break;
        if (RAW_TEXT_TAGS.has(name)) {
            const close = lower.indexOf(`</${name}`, offset);
            if (close < 0) break;
            offset = close;
            continue;
        }
        if (templateDepth === 0 && (name === 'html' || name === 'body') && roots[name] === undefined) {
            roots[name] = html.slice(start + prefix[0].length, end);
        }
    }
    return roots;
};
